import makeStyles from '@mui/styles/makeStyles';
import { get } from 'global/lib/lodash';

const IMAGE = 100;

const useStyles = makeStyles((theme) => ({
  blockOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: -100,
    backgroundColor: 'rgba(255,0,0,0.1)',
  },
  comment: {
    width: '100%',
    backgroundColor: (props) => (get(props, 'formState.overwritten') ? theme.palette.background.paper : theme.palette.action.disabled),
    boxShadow: 'inset 2px 2px 5px rgba(0,0,0,0.3)',

    '& .MuiOutlinedInput-root': {
      border: 'none !important',
      padding: '6px 0 7px',

      '& fieldset': {
        border: 'none !important',
      },
      '& input': {
        padding: 0,
      }
    },
    '& textarea': {
      margin: theme.spacing(1),
    },
    '& .MuiFormHelperText-root': {
      position: 'relative',
      bottom: -20,
      marginLeft: 0,
    },
  },
  cameraContainer: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0,0,0,0.8)',
  },
  closeCamera: {
    position: 'absolute',
    top: 10,
    right: 10,
  },
  imageWrap: {
    position: 'relative',
    margin: theme.spacing(1),
    width: IMAGE,
  },
  image: {},
  imageDelete: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
  commentWithClose: {
    '& textarea': {
      marginRight: theme.spacing(5),
    },
  },
  commentBtnContainer: {
    marginTop: 27,
  },
  commentBtn: {
    width: '100%',
    marginBottom: 5,
    position: 'relative',

    '& .placeholderContent': {
      width: IMAGE,
      height: IMAGE + 40,
      backgroundColor: theme.palette.action.disabledBackground,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  commentBtnClose: {
    position: 'absolute',
    top: 5,
    right: 5,
  },
  imageSelectBtn: {
    position: 'absolute',
    top: 7,
    left: 5,
  },
  expandBtn: {
    width: '100%',
    color: theme.palette.text.primary,
  },
}));

export default useStyles;
